import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const LegalWarningDialog = ({open, onClose}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle sx={{m: 0, p: 2}}>
                Legal notice
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <ul style={{paddingLeft: 24}}>
                    <li>
                        The content provided by the Socioeconomic and Governance tool is
                        published for informational purposes only and does not replace
                        the information included in official sources.
                    </li>
                    <li>
                        The information is compiled using quality protocols and every
                        effort is made to ensure that it is accurate and up to date.
                        However, CETMAR does not guarantee that the content of this site
                        is free of errors or that it is completely up to date.
                    </li>
                    <li>
                        CETMAR is not responsible for any damage or loss that may be
                        caused by the illegitimate or inappropriate use of the website.
                    </li>
                    <li>
                        CETMAR assumes no responsibility for the connection or the
                        contents of links to external pages referred to on the website.
                    </li>
                    <li>
                        CETMAR reserves the right to make modifications and updates to
                        the information contained or its configuration or presentation
                        at any time and without prior notice.
                    </li>
                </ul>
            </DialogContent>
        </Dialog>
    );
};

export default LegalWarningDialog;
